export default "__VITE_ASSET__BXdD2ApN__"